const smart_punctuation_replacements: Record<string, string> = {
  '\u2018': '\'',
  '\u2019': '\'',
  '\u201A': '\'',
  '\u201B': '\'',
  '\u2032': '\'',
  '\u2035': '\'',
  '\u201C': '"',
  '\u201D': '"',
  '\u201E': '"',
  '\u201F': '"',
  '\u2033': '"',
  '\u2036': '"',
  '\u2010': '-',
  '\u2011': '-',
  '\u2012': '-',
  '\u2013': '-',
  '\u2014': '-',
  '\u2015': '-',
  '\u2212': '-',
  '\u2026': '...',
  '\u2022': '*',
  '\u00A0': ' ',
  '\u2007': ' ',
  '\u202F': ' ',
  '\u00AE': '(R)',
  '\u00A9': '(C)',
  '\u2122': '(TM)',
};

const smart_punctuation_regex = new RegExp(
  `[${Object.keys(smart_punctuation_replacements).join('')}]`,
  'g',
);

function normalizeSmartPunctuation(value: string): string {
  return value.replace(
    smart_punctuation_regex,
    (character) => smart_punctuation_replacements[character] || character,
  );
}

export default normalizeSmartPunctuation;
